import { render, staticRenderFns } from "./SugestaoDeCompra.vue?vue&type=template&id=6b47ae32&scoped=true"
import script from "./SugestaoDeCompra.vue?vue&type=script&lang=js"
export * from "./SugestaoDeCompra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b47ae32",
  null
  
)

export default component.exports